import { PropTypes } from 'prop-types';
import React from 'react';
import { classnames } from 'tailwindcss-classnames';

import { transformArticleData } from '../../utils';
import CardFunPairingComment from '../Cards/CardFunPairing/CardFunPairingComment';
import CardImageBasedSmall from '../Cards/CardImageBased/CardImageBasedSmall';
import CardImageBasedXLargeStatic from '../Cards/CardImageBased/CardImageBasedXLargeStatic';

const HomepageHeroLatelyTop = ({ comments, header }) => {
  const primaryCard = transformArticleData(header[0]);
  const secondaryCards = header.slice(1);

  return (
    <div
      className="mt-8 homepage-grid-container mb-14 lg:mt-18 mb-18"
      data-module-id="homepage_hero_lately_top"
    >
      <div className="col-span-12 mb-8 sm:mb-14 lg:mb-0">
        <CardImageBasedXLargeStatic
          date={primaryCard.publishedDate}
          franchise={primaryCard.franchise}
          header={primaryCard.header}
          image={primaryCard.cardImage}
          slug={primaryCard.slug}
          tags={primaryCard.tags}
          title={primaryCard.title}
          url={primaryCard.url}
        />
      </div>
      <div
        className="grid grid-cols-2 col-span-12 lg:col-span-8 sm:grid-cols-4 lg:grid-cols-2 homepage-grid-gaps h-[fit-content] gap-y-8"
        data-component-id="homepage_hero_lately_top_link"
      >
        {secondaryCards.map((item, index) => {
          const { cardImage, franchise, id, publishedDate, slug, tags, title } =
            transformArticleData(item);

          const props = {
            date: publishedDate,
            franchise,
            image: cardImage,
            slug,
            tags,
            title,
          };

          switch (index) {
            case 0:
              return (
                <div key={id} className="order-1">
                  {React.createElement(CardImageBasedSmall, {
                    ...props,
                  })}
                </div>
              );
            case 1:
              return (
                <div key={id} className="order-2 sm:order-3 lg:order-2">
                  {React.createElement(CardImageBasedSmall, {
                    ...props,
                  })}
                </div>
              );
            case 2:
              return (
                <div
                  key={id}
                  className="order-3 col-span-2 sm:order-2 lg:order-3 sm:col-span-1"
                >
                  {React.createElement(CardImageBasedSmall, {
                    ...props,
                    imageClassName: 'h-64 sm:h-32 lg:h-44 image-hover',
                  })}
                </div>
              );
            case 3:
              return (
                <div key={id} className="order-4 col-span-2 sm:col-span-1">
                  {React.createElement(CardImageBasedSmall, {
                    ...props,
                    imageClassName: 'h-64 sm:h-32 lg:h-44 image-hover',
                  })}
                </div>
              );
            default:
              return null;
          }
        })}
        <div className="grid order-5 grid-cols-1 col-span-full sm:grid-cols-2 homepage-grid-gaps">
          {comments.map((item, index) => {
            const { author, id, image, link, title } = item;

            const card = (
              <CardFunPairingComment
                author={author}
                image={image}
                title={title}
                url={link?.url}
              />
            );

            const baseCommentClass = classnames(
              'py-6',
              'border-t',
              'lg:py-10',
              'sm:py-4',
              'border-smoke',
            );

            const firstCommentClass = classnames(
              baseCommentClass,
              'sm:border-b',
            );
            const secondCommentClass = classnames(baseCommentClass, 'border-b');

            return (
              <div
                key={id}
                className={index === 0 ? firstCommentClass : secondCommentClass}
              >
                {card}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

HomepageHeroLatelyTop.propTypes = {
  comments: PropTypes.array,
  header: PropTypes.array,
};

export default HomepageHeroLatelyTop;
